import React, { useEffect, useState } from 'react';
import { Button, List } from '@meitu/saas-ui';
import { imageConverter } from '@meitu/saas-editor-core/es/utils/file-kit';
import { MaterialCard } from '@meitu/saas-editor-ui/es/components/material-card';
import IconFont from '@meitu/xdesign-icon-font';
import { useDragLayer } from '@/hooks/use-drag-layer';
import { useLocaleStore } from '@/i18n';
import { fetchMaterialSearchList } from '@/services/material';
import { MaterialListItem } from '@/services/material/index.d';
import { checkShowSvipCorner } from '@/utils/ab-test';
import { useSelectMaterial } from '../../hooks/use-select-material';

interface IMaterialDetailList {
    keyword: string;
}
// 每个分页请求多少个素材
const Material_SIZE = 50;

const MaterialDetailList = (props: IMaterialDetailList) => {
    const { $t } = useLocaleStore();
    const { keyword } = props;

    const [materialList, setMaterialList] = useState<MaterialListItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [isNetwork, setIsNetwork] = useState<boolean>(true);
    const [cursor, setCursor] = useState<string | null>(null);

    const selectMaterial = useSelectMaterial();
    const dragLayerHelper = useDragLayer();

    const fetchMaterialList = async () => {
        try {
            if (!hasMore || loading) {
                return;
            }
            setLoading(true);

            const {
                data: { response },
            } = await fetchMaterialSearchList({
                keyword,
                cursor: cursor || undefined,
                count: Material_SIZE,
                type: 'pic_static_sticker',
            });
            const materials =
                response.materials?.map((item: any) => {
                    return {
                        material_conf: item.material_conf,
                        name: item.default_name || '',
                        threshold: item.threshold || 0,
                        id: item.id || 0,
                        thumbnail: item.thumbnail || {},
                        zip_url: item.zip_file?.url || '',
                        corner_mark: item.corner_mark || {},
                        svg: item.svg,
                    };
                }) || [];

            if (materials.length) {
                setIsNetwork(true);
                setMaterialList((v) => materialList.concat(materials));
            }
            setCursor(response.cursor || '');
            setHasMore(!!response.cursor);
            setLoading(false);
        } catch (error) {
            if (error === $t((v) => v.collapse.messageError.networkFailed)) {
                setIsNetwork(false);
            }
        }
    };

    useEffect(() => {
        setHasMore(true);
        setMaterialList([]);
        setCursor(null);
    }, [keyword]);

    useEffect(() => {
        cursor === null && fetchMaterialList();
    }, [cursor]);

    const handleCardClick = (data: MaterialListItem, byMousePosition = false) => {
        selectMaterial.append(data, byMousePosition);
    };

    return (
        <div className="c-material-collapse-search" style={{ width: 272, marginLeft: -6 }}>
            {isNetwork ? (
                <>
                    <List<MaterialListItem>
                        bodyClassName="m-material-list "
                        loading={loading}
                        hasMore={hasMore}
                        dataSource={materialList}
                        nextPageRequest={fetchMaterialList}
                        id="materialSearchList"
                        renderItem={(data) => {
                            return (
                                <div
                                    draggable="true"
                                    onMouseDown={(ev) =>
                                        dragLayerHelper.init(
                                            {
                                                naturalWidth: data.material_conf?.width,
                                                naturalHeight: data.material_conf?.height,
                                                callback: () => handleCardClick(data as MaterialListItem, true),
                                            },
                                            ev,
                                        )
                                    }
                                    onMouseUp={() => {
                                        dragLayerHelper.destroy();
                                    }}
                                >
                                    <MaterialCard
                                        key={data.id}
                                        width={79}
                                        cardStyle={{ height: 79 }}
                                        src={imageConverter(data.thumbnail, 320)}
                                        cornerSrc={
                                            checkShowSvipCorner()
                                                ? typeof data.corner_mark === 'string'
                                                    ? data.corner_mark
                                                    : ((data.corner_mark as any)?.url ?? '')
                                                : ''
                                        }
                                        cornerPlacement="topRight"
                                        onClick={() => handleCardClick(data)}
                                    />
                                </div>
                            );
                        }}
                    />
                </>
            ) : (
                <div className="no-network">
                    <div className="no-network__img">
                        <IconFont fontSize={98} name="planet" color="#cfd9f2" />
                    </div>
                    <div className="no-network__text">
                        {$t((v, { n }) => n(v.collapse.materialCollapse.tips.noNetwork, [<br key="line-break" />]))}
                    </div>
                    <Button
                        type="primary"
                        onClick={() => {
                            fetchMaterialList();
                        }}
                        shape="round"
                    >
                        {$t((v) => v.collapse.materialCollapse.reload)}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default React.memo(MaterialDetailList);
